import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import type { ModalData } from '@white-label-types/modal';
import GlobalModalError from '../global-modal-error/global-modal-error.vue';
import { useRoute } from 'vue-router/composables';

type ComponentTypes = 'GlobalModalError';
type DefaultModalDataType = { [key in ComponentTypes]: ModalData };


export default /*#__PURE__*/_defineComponent({
  __name: 'modal-container',
  setup(__props) {

const DEFAULT_MODAL_DATA: DefaultModalDataType = {
  GlobalModalError: {
      closeOnClickOutside: false,
      isSuccess: false,
      isWarning: false,
      header: '',
      body: '',
      btnType: 'custom',
  },
} as const;

const component = ref<ComponentTypes | ''>('GlobalModalError');
const data = ref<ModalData | null>(null);
const route = useRoute();
const vm = getCurrentInstance();

const eventEmitter = computed(() => vm?.proxy.$global_eventEmitter);

const getComponent = computed(() => {
  if (component.value && data.value?.header) {
      return GlobalModalError;
  }
  return null;
});

const preparseModalData = (data: ModalData, component: ComponentTypes): ModalData => {
  return {
      ...DEFAULT_MODAL_DATA[component],
      ...data,
  };
};

const close = (callback?: Function): void => {
  window.dispatchEvent(
      new CustomEvent('modalClose', {
      detail: callback,
      })
  );
  data.value = null;
  component.value = '';
  document.querySelector('body')?.classList.remove('no-animation');
};

const setModalDataListener = ({
    component: componentType,
    data: modalData,
  }: {
    component: ComponentTypes;
    data: ModalData;
  }): void => {
    data.value = preparseModalData(modalData, componentType);
    component.value = componentType;
    document.querySelector('body')?.classList.add('no-animation');
};

watch(() => route.name, () => {
  close();
})

onMounted(() => {
  eventEmitter.value?.$on('setModalData', setModalDataListener)
});

onBeforeUnmount(() => {
  eventEmitter.value?.$off('setModalData', setModalDataListener);
});

return { __sfc: true,DEFAULT_MODAL_DATA, component, data, route, vm, eventEmitter, getComponent, preparseModalData, close, setModalDataListener }
}

})